import "../css/bootstrap.css";
import "../css/MainYaba.css";

function MainContoYaba() {
    return (
        <main class="bg-image text-white yaba">
            <div class="conteiner text-center pt-5">
                <h1>AFROFUTURISMORISMO</h1>
                <p><b>O que acham que é:</b> Uma subdivisão do Futurismo, movimento artístico e literário que surgiu em 1909.</p>
                <p><b>O que realmente é:</b> Afrofuturismo é um movimento cultural, social e político, cuja produção 
                promove o encontro entre ficção científica, tecnologia, realismo fantástico, ancestralidade, mitologia e diáspora africana negra. Suas narrativas — na música, nas artes plásticas, na literatura, nos quadrinhos, na moda, no cinema etc — dizem respeito, necessariamente, à população negra.</p>
                <p><b>Kênia Freitas</b>, pesquisadora, crítica de cinema e curadora da mostra Afrofuturismo:
                Cinema e Música em uma Diáspora Intergaláctica, que aconteceu em 2015, em São Paulo, diz que se trata de um movimento vivo e em construção. 
                <i>“Desta forma, há muitas definições. A que prefiro é a que pensa o Afrofuturismo como um movimento político e estético que explora narrativas de ficção especulativa a partir da perspectiva negra. 
                Algumas vislumbram a possibilidade de novos futuros para a população negra, enquanto outras trabalham reelaborando o passado ou fabulando o presente”</i>, afirma.</p>
            </div>
        </main>
                )
}

                export default MainContoYaba;